<template>
  <div id="init-home-container" class="mt-3 d-flex" style="width: 100%">
    <!--      
   13 Souls Run APP v0.8.1
    Copyright (c) 2026 Blue Cover Six LLC / John Molt
    BCS grants Unlimited License to 13 Souls LLC and Jeff Von Molt -->

    <!--<auth></auth>-->

    <v-spacer></v-spacer>
    <v-main>
      <v-container
        class="cmpbk white--text"
        id="home-container"
        style="max-width: 768px"
      >
        <v-row class="menu">
          <v-col cols="12" class="d-flex flex-row justify-space-around">
            <div class="d-flex flex-column justify-start align-center">
              <h2>The 13 Souls Run</h2>
              <h3>
              <!-- <a class="light-blue--text" href="/register">Register Now</a> -->
                <div> To register to partcipate, please click 
                  <a class="light-blue--text" href="/participant">Here</a> </div> 
                <div>  To volunteer, please click
                  <a class="light-blue--text" href="/volunteer">Here</a> </div>
                </h3>
            </div>
          </v-col>
        </v-row>

        <v-row id="about" class="about">
          <v-col cols="12">
            <h4>
              The 13 Souls Run is a tribute to the military men & women who lost their lives during the tragic events that unfolded on August 26, 2021, during the evacuation at the Karzai Airport in Kabul, Afghanistan. A suicide bomber killed 13 U.S. service members and critically wounded 18 U.S. service members, while also killing 170 Afghan citizens trying to escape the incoming Taliban regime that fateful evening.
            </h4>
            <br />
            <h4 class="">
              The 13 Souls Run was born from the horror of that day in Afghanistan to reflect, remember and honor the
              brave men and women who gave all on August 26, 2021.
                            <!-- <a
                class="light-blue--text"
                href="https://www.givesendgo.com/13soulsrun2024"
                target="_blank"
                >GiveSendGo 13soulsrun</a
              > -->
              </h4> <br />
            <h4 class="">            Now as we mark the 5th Anniversary of remembering those we lost, we turn our gaze toward an ongoing tribute by partnering with local non-profit Vets & Valor. Since 2023 Vets & Valor has helped veterans around Ventura County and beyond with life changing resources for benefits they have earned during their time in service.
            </h4>   <br />
            <h4>
              This new partnership will keep this event continuing forward and growing, while helping our community come together for years in the future, to pause and reflect with the 13 Souls Run, while establishing a lasting daily tribute as veterans that have bravely served are helped as a result of the 31 who sacrificed for us all five years ago on August 21, 2021.

            </h4>
            <br />
            <h4>
            Money collected from this event will be donated to support the memorial & scholarship funds created by the families of our 13 in their child's names as well as Vets & Valor’s efforts to support veteran causes.
            </h4>
            <br />
            <h4>
            Please donate to this worthy cause at <a class="light-blue--text" href="https://www.givesendgo.com/13soulsrun2026" target="_blank">GiveSendGo.com/13soulsrun2026</a> This event is a 1k, 5k, 10k, ½ Marathon. This is a morning of celebration and reflection to honor those we lost and who were critically wounded on August 26th, 2021 and to enjoy the City of Simi Valley. This is a fun, community event celebrating life and the freedoms we have here in the United States with entertainment, vendors and city services. There are no prizes given for run placement at this event.
            </h4>
            <br />
             <h4 class="light-blue--text">
            This event will take place Saturday morning, August 22nd, 2026, with registration/check-in starting at 5:30 a.m., and ceremonies starting at 6:15 a.m. Participants will be released on course at roughly 7:00am.
            </h4>
            <br />
            <h4>
              Breakfast will be provided to all registered participants, prepared and donated by the Y’s Men of the Simi Valley YMCA Men’s Group. 
            </h4>
            <br />
          </v-col>
        </v-row>

        <v-row id="registration" class="reg_form mb-5">
              <h3>
        <!-- <a class="light-blue--text" href="/register">Register Now</a> -->
          <div> To register to partcipate, please click 
            <a class="light-blue--text" href="/participant">Here</a> </div> 
          <div>  To volunteer, please click
            <a class="light-blue--text" href="/volunteer">Here</a> </div>
          </h3>
        </v-row>
        <!-- <h1 class="white--text">Hello World</h1> -->
      </v-container>
    </v-main>
    <v-spacer></v-spacer>
  </div>
</template>

<style lang="scss" scoped>
@import "../scss/site.scss";

/* 0 media q */

@media (min-width: 0px) {
  .bkclr {
    background-color: rgb(0, 25, 48);
    padding: 8px;
  }
  #home-container {
    width: 100vw;
    max-width: 100vw;
    height: auto;
  }

  .results .v-expansion-panel-content::v-deep .v-expansion-panel-content__wrap,
  .recent .v-expansion-panel-content::v-deep .v-expansion-panel-content__wrap {
    padding: 0 7px !important;
  }

  .menu h4 {
    color: aliceblue;
  }

  .about .light-blue {
    color: lightblue;
  }
}

/* 768 media q *
@media (min-width: 768px) {
}

/* 1025 media q */
@media (min-width: 1025px) {
}

/* 2048 media q */
@media (min-width: 2048px) {
}
</style>

<script>
/* eslint-disable */
import { bus_common } from "../mixins/bus_common";
import register from "../components/register.vue";

//const add_edit = () => import("./add_edit.vue");

export default {
  name: "Home",
  components: {
    register,
  },
  mixins: [bus_common],
  data() {
    // Status, Fname, Lnprivateame, DOB, DIVISION
    return {};
  },
  watch: {
    "$store.state.user": function () {
      //keep this
      let self = this;
      this.init();
    },
  },
  methods: {
    /* sendRequest(rowData) {
      console.log(rowData);
    }, */
    sendRequest() {
      alert("This button does nothing yet.");
    },
    message1() {
      alert("This button does nothing yet.");
    },

    init(self) {
      this.show_loader(false);
    },
  },
  mounted() {
    var self = this;
    this.$nextTick(() => {
      this.init(self);
    });
  },
};
</script>
